import { Button, Form, Input, InputRef, Layout, Modal, Select, Space, Table, TablePaginationConfig, Upload } from "antd";
import { Content } from "antd/lib/layout/layout";
import Sider from "antd/lib/layout/Sider";
import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./SupplierMyProductScreen.module.css";
import { useHistory, useLocation, useRouteMatch } from "react-router";
import useLoading from "../../hooks/useLoading";
import { useUserContext } from "../../Context/UserContext";

import { SplitButton } from "primereact/splitbutton";
import { Editor } from "@tinymce/tinymce-react";
import { PlusOutlined } from '@ant-design/icons';
import type { RcFile, UploadProps } from 'antd/es/upload';
import type { UploadFile } from 'antd/es/upload/interface';
import { ISupplierProductModel } from "../../IRequestModel/ECatalog/ISupplierProductModel";
import { InsertSupplierProduct, GetSupplierProduct, UploadImage, GetSupplierProductImage, UpdateSupplierProduct, ImportProduct, RemoveImage, GetMasterProductImage } from "../../Services/e-pro/SupplierECatalogService";
import { SupplierProductData } from "../../Services/e-pro/models/SupplierProductModel";
import { CreateMemorandum, GetAllMasterCategotryGroup, GetSellerById, GetWolfTemplate, SearchCatalogItem } from "../../Services/e-pro/EcatalogService";
import useAuthRedcross from "../../hooks/useAuthRedcross";
import { exportExcel } from "../../Helper/ExportExcel";
import Swal from "sweetalert2";
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { IProductItem } from "../../IRequestModel/ECatalog/IProductItemModel";
import { MapsDataToProductObject } from "../../Helper/ECatalogHelper";
import { getSellerByEmpCode } from "../../Services/e-pro/SupplierService";
import { UpdateCategoryItemStock } from "../../Services/e-pro/CatalogMasterDataService";

export type CategoryItemStockModel = {
  StockID?: number;
  ItemID : string;
  ItemStock? : number;
  ItemPrice? : number;
};

const SupplierMyProduct = () => {

    //const [text, setText] = useState<string>("");
    // const [itemsCount, setItemsCount] = useState<number>(0);
    // const [supplierList, setSupplierList] = useState<SupplierProductData[]>();
    // const [tableData, setTableData] = useState<any[]>([]);
    // const [supplierColumns, setSupplierColumns] = useState<any[]>();
    // const [visibleDialog, setVisibleDialog] = useState<boolean>(false);
    // const [template, setTemplate] = useState<any>([]);
    const { isLoad, setLoad } = useLoading();

    const [userData] = useUserContext();
    const [emp_data, setEmp_data] = useState<any>();
    const [_baseUrl, setbaseUrl] = useState<string>();
    const [isAdmin, setIsAdmin] = useState<boolean>(true);
    const { search } = useLocation();
    const query = useMemo(() => new URLSearchParams(search), [search]);
    const [isAutoReport, setIsAutoReport] = useState<boolean>(false);
    const [canEdit, setCanEdit] = useState<boolean>(false);
    const { url } = useRouteMatch();
    const [selectedRows, setSelectedRows] = useState<number[]>([]);

    const [form] = Form.useForm();
    const [form2] = Form.useForm();
    
    const [itemOnModal, setItemOnModal] = useState<IProductItem>();
    const [itemOnModalStock, setItemOnModalStock] = useState<IProductItem>();

    const [openModal, setOpenModal] = useState(false);
    const [openModalStock, setOpenModalStock] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [contentEditor, setContentEditor] = useState();
    const [categoryItem, setCategoryItem] = useState<any>([]);

    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [fileListRemove, setFileListRemove] = useState<UploadFile[]>([]);
    const [exportLoading, setExportLoading] = useState<boolean>(false);
    const [tableLoading, setTableLoading] = useState<boolean>(false);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>(null);
    const inputFile = useRef(null) 
    const [products, setProducts] = useState<IProductItem[]>([]);
    const [sellerInfo, setSellerInfo] = useState<any>();
    const [tableDataExport, setTableDataExport] = useState<any[]>([]);

    let history = useHistory();

    type DataIndex = keyof SupplierProductData;
    const { TextArea } = Input;
    const [paginationOption, setPaginationOption] =
      useState<TablePaginationConfig>({
        position: ["bottomLeft"],
        size: "small",
        current: 1,
        showSizeChanger: true,
        onChange: (page, pageSize) => {
          let _page: TablePaginationConfig = paginationOption;
          _page.current = page;
          _page.pageSize = pageSize;
  
          setPaginationOption(_page);
        },
      });
  
      // const sidebar = permission.sidebar.map((data, i) => {
      //   return (
      //     <div key={i}>
      //       <div
      //         style={{
      //           fontSize: "1.3rem",
      //           fontWeight: "bold",
      //           // marginBottom: "4px",
      //         }}
      //       >
      //         {data.name}
      //       </div>
      //       {data.sub.map((value, i) => {
      //         return (
      //           <div
      //             key={i}
      //             onClick={() => handleSidebarClick(value.key)}
      //             style={{
      //               color: activeSidebar === value.key ? "red" : "",
      //               cursor: "pointer",
      //               fontSize: "1.3rem",
      //               marginBottom: "6px",
      //             }}
      //           >
      //             &emsp;
      //             {value.key === "petition"
      //               ? `${value.name} (${workList?.length ?? 0})`
      //               : value.name}
      //           </div>
      //         );
      //       })}
      //     </div>
      //   );
      // });
  
    useEffect(() => {
      getSellerInfo();
     
    
    }, []);

    useEffect(() => {
      getProductCategory();
    
      getProducts();
    
    }, [sellerInfo]);

    async function getSellerInfo(){
      
      let response = await getSellerByEmpCode(userData.EmployeeCode);
      const data = response.data;

      setSellerInfo(data);
    }

    async function getProducts() {
      setTableLoading(true);

      const dataJson = {
          searchItem : "",
          Catagoly :0,
          EmployeeId: 0
        };
      let response = await SearchCatalogItem(dataJson);
      const data = response.data;
     
      if (data === undefined || sellerInfo === undefined ) return;
      var filterData = data.filter(x => x.SellerID === sellerInfo.SellerID);
      let productItem: IProductItem[] = MapsDataToProductObject(filterData);

      setProducts(productItem);


      if (productItem !== undefined)
      {
        let mapValueToKey: { [name: string]: string } = {
          itemId: "รหัส",
          title: "ชื่อสินค้า",
          itemStock: "จำนวน"
        };
        const transformedData = transformKeys(productItem, mapValueToKey);
  
        setTableDataExport([...transformedData]);
      }
      setTableLoading(false);
      //console.log(productItem);
    }
    async function getProductCategory() {
      const response = await GetAllMasterCategotryGroup();
      const data = response.data;
      if (data !== undefined){
        let selectItem: { value: any; label: any; }[] = [];
        data.map((item) => {
          selectItem.push(
            {
              value: item.rowID,
              label: item.Text,
            }
          )
         
        });
        setCategoryItem(selectItem);
        //fetchReport(selectItem);
      }
      //console.log(data); 
    }
  
  
    const actionBodyTemplate = (record: any) => {
      const adminActionBody = [
        {
          label: "Edit",
          icon: "pi pi-pencil",
          command: async () => {
            console.log(record);
            setItemOnModal(undefined);
            setContentEditor((prevState: any) => ({
              ...prevState,
              value: "",
            }));
            setFileList([]);
            setFileListRemove([]);

            let filterItem = products?.filter(x => x.id === record.id)[0];
            setItemOnModal(filterItem);
            
            setContentEditor((prevState: any) => ({
              ...prevState,
              value: filterItem?.itemProperties != null ? filterItem?.itemProperties : "",
            }));
            
            let tempImage = await GetMasterProductImage({ ItemRowId: record.id});
            var tempUploadFile : UploadFile[] = [];

            //tempImage.data?.map(async (img) => {
              for (const img of tempImage.data){
                try {
                  // Fetch the file content
                  const response = await fetch(img.ItemPicPath);
                  if (!response.ok) throw new Error("Failed to fetch file");
            
                  const blob = await response.blob(); // Get the file content as a Blob
                  //const file = new File([blob], img.ItemPicName, { type: blob.type }); // Create a File object
                      // Create an RcFile object
                  const rcFile = new File([blob], img.ItemPicName, { type: blob.type });
                  //(rcFile as any).lastModifiedDate = new Date(); // Set lastModifiedDate property
                  //(rcFile as any).uid = Date.now().toString(); // Set unique identifier
                  // Add the file to the upload list
                  const newFile = {
                    uid: img.Guid,//Date.now().toString(),
                    name: img.ItemPicName,//file.name,
                    status: "done",
                    originFileObj: rcFile,
                    url: URL.createObjectURL(rcFile), // Optional: Preview URL
                  };
  
                  //console.log(newFile);
                  // tempUploadFile.push({
                  //   uid: img.Guid,//Date.now().toString(),
                  //   name: img.ItemPicName,//file.name,
                  //   status: "done",
                  //   originFileObj: rcFile,
                  //   url: URL.createObjectURL(rcFile), // Optional: Preview URL
                  // });
                  //setFileList([...fileList, newFile]);
                  tempUploadFile.push(newFile);
                  //message.success("File added successfully!");
                } catch (error) {
                  console.error("Error adding file:", error);
                  //message.error("Failed to add file.");
                }
              }
              


              // tempUploadFile.push({
              //   uid : img.Guid,
              //   name: img.ItemPicName,
              //   status: 'done',
              //   url: img.ItemPicPath
              // });
            //})
            setFileList(tempUploadFile)


            setOpenModal(true);
          },
        },
        {
          label: "Edit Stock",
          icon: "pi pi-pencil",
          command: async () => {
            console.log(record);
            setItemOnModalStock(undefined);
            
            // setFileList([]);
            // setFileListRemove([]);

            let filterItem = products?.filter(x => x.id === record.id)[0];
            setItemOnModalStock(filterItem);
            setOpenModalStock(true);
          },
        },
        // {
        //   label: "Delete",
        //   icon: "pi pi-trash",
        //   command: () => {
        //     confirmDialog({
        //       message: "Do you want to delete this report.",
        //       header: "Delete",
        //       icon: "p-confirm-dialog-icon pi pi-info-circle",
        //       rejectClassName: "hide",
        //       acceptClassName:
        //         "p-button p-component p-confirm-dialog-accept table-accept p-button-danger table-control-confirm-button p-button-accept-cancel",
        //       accept: async () => {
        //         const res = await DeleteReport(record.ReportTemplateId);
        //         if (res) {
        //           setLoad(true);
        //           fetchReport();
        //         }
        //       },
        //     });
        //   },
        // },
      ];
      let _user: any = userData;
      if (query.get("usrId")) {
        _user = emp_data.find((e: any) => e.EmployeeId === query.get("usrId"));
      }
  
      if (isAdmin && !query.get("usrId")) {
        return (
          <React.Fragment>
            <SplitButton
              // id
              className="p-button-secondary"
              model={adminActionBody}
              dropdownIcon="pi pi-ellipsis-v"
            />
          </React.Fragment>
        );
      } else if (
        record.CreatedBy === _user.NameTh ||
        record.CreatedBy === _user.NameEn
      ) {
        return (
          <React.Fragment>
            <SplitButton
              className="p-button-secondary"
              model={adminActionBody}
              dropdownIcon="pi pi-ellipsis-v"
            />
          </React.Fragment>
        );
      }
    };
  

    const uploadButton = (
      <div>
        <PlusOutlined rev={undefined} />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
      setFileList(newFileList);
    }
    const handleEditorChange = (content: any, editor: any) => {
      setContentEditor((prevState: any) => ({
        ...prevState,
        value: content,
      }));
    };

    useEffect(() => { 
      form.resetFields();
      if (itemOnModal != undefined){
          form.setFieldsValue({
                id: itemOnModal.id,
                itemId : itemOnModal.itemId,
                catagolyGroupItemID : itemOnModal.catagolyGroupItemID,
                title : itemOnModal.title,
                description : itemOnModal.description,
                itemProperties : itemOnModal.itemProperties,
                itemUnit : itemOnModal.itemUnit,
                price : itemOnModal.price,
                Contract: itemOnModal.Contract,
          });
      }
      

    }, [itemOnModal]);

    useEffect(() => { 
      form2.resetFields();
      if (itemOnModalStock != undefined){
          form2.setFieldsValue({
                id: itemOnModalStock.id,
                itemId : itemOnModalStock.itemId,
                catagolyGroupItemID : itemOnModalStock.catagolyGroupItemID,
                title : itemOnModalStock.title,
                description : itemOnModalStock.description,
                itemProperties : itemOnModalStock.itemProperties,
                itemUnit : itemOnModalStock.itemUnit,
                price : itemOnModalStock.price,
                itemStock : itemOnModalStock.itemStock
          });
      }
      

    }, [itemOnModalStock]);

    const handleSaveModal = async (values) => {

      Swal.fire({
        title: "ยืนยันบันทึกข้อมูลสินค้า",
        text: "การบันทึกเพื่อแก้ไขข้อมูลสินค้าจะต้องทำการอนุมัติเพื่อปรับปรุงข้อมูล",
        //icon: "question",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ไม่ยืนยัน",
        showCancelButton: true,
        confirmButtonColor: "#1890ff",
        cancelButtonColor: "#c95558",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setTableLoading(true);

        setConfirmLoading(true);

        let inserttItem: ISupplierProductModel = {
            ItemID : values.itemId,
            CatagolyGroupItemID : values.catagolyGroupItemID,
            SellerID : sellerInfo.SellerID,//userData.EmployeeId,
            ItemName : values.title,
            ItemDescription : values.description,
            ItemPropertise : contentEditor?.value,
            ItemUnit : values.itemUnit,
            IsActive : true,
            ItemPrice : values.price,
            Contract : values.Contract,
            CreatedBy : userData.EmployeeId.toString(),
            ModifiedBy : userData.EmployeeId.toString(),
            EditMode : "EDIT",
            SendToProcess : true,
            RowID: values.id
        }
        
        
        await PrcessObjectJson(inserttItem);
      
        // console.log('valie modal:', values);

        // if (returnData.data != undefined && returnData.data.RowID !== 0) {
        //   let temp1 = await UploadImage(
        //     fileList,
        //     returnData.data.RowID,
        //     userData.EmployeeId.toString(),
        //     userData.EmployeeId.toString()
        //   );
        //   if (fileListRemove.length > 0){

        //     let removeItem = fileListRemove.filter(x => x.originFileObj === undefined)?.map(a => a.uid);
        //     if (removeItem.length > 0)
        //       await RemoveImage(removeItem);
        //   }
        
        // }

        form.resetFields();
        setConfirmLoading(false);
        //fetchReport(categoryItem);
        setOpenModal(false)

        }
      });

        
      }

    async function PrcessObjectJson(itemUpdate:ISupplierProductModel){
        //setIsCardLoading(true);
        
        try{

          let retunInsert = await InsertSupplierProduct(itemUpdate);
          // let temp1 = await UploadImage(
          //   fileList,
          //   itemUpdate.RowID,
          //   userData.EmployeeId.toString(),
          //   userData.EmployeeId.toString()
          // );


          if (retunInsert.data != undefined && retunInsert.data.RowID !== 0) {
            let temp1 = await UploadImage(
              fileList,
              retunInsert.data.RowID,
              userData.EmployeeId.toString(),
              userData.EmployeeId.toString()
            );
            
          
          }

          let itemImage = [];
          let tempImage = await GetSupplierProductImage({ ItemRowId: retunInsert.data.RowID});
          if (tempImage.data == null){
            //countCheckNoImage.push(item.RowID)
          }
          else
          {
            itemImage.push({
              ItemRowId: retunInsert.data.RowID,
              imageData: tempImage.data
            })
          }

            //setLoadingsSendOrder(true);
            var templateForm = await GetWolfTemplate("E-Catalog");
            console.log(templateForm);
            if (templateForm !== null)
            {
              //let sellerInfo = await GetSellerById(userData.EmployeeId);
              let sellerInfo = await getSellerByEmpCode(userData.EmployeeCode);
              
              templateForm.form.map((_template) => {
                let setValue = null;
                switch (_template.template.label) {
                    case "ชื่อผู้ค้า":
                        setValue = sellerInfo.data.SellerName;
                        break;
                    case "ประเภทกิจการ":
                        setValue = sellerInfo.data.BussniesType !== undefined ? sellerInfo.data.BussniesType : "";
                        break;
                    
                    case "เลขประจำตัวผู้เสียภาษี":
                        setValue = sellerInfo.data.TaxpayerIdentificationNo !== undefined ? sellerInfo.data.TaxpayerIdentificationNo : "";
                        break;
                    case "วันที่ลงทะเบียน":
                        setValue = sellerInfo.data.DateOfRegisteration !== undefined ? sellerInfo.data.DateOfRegisteration?.toString() : "";
                        break;
                    case "หมายเลขโทรศัพท์":
                        setValue = sellerInfo.data.PhoneNumber !== undefined ? sellerInfo.data.PhoneNumber : "";
                        break;
                    case "e-mail":
                        setValue = userData.Email;
                        break;
                      case "รายละเอียดข้อมูลสินค้า":
                          //     // set data as table to row array
                        let rowItem = [];
                        var catItem = categoryItem.filter((x) => x.value === itemUpdate.CatagolyGroupItemID)[0];
                       
                      //  let itemDesc = `ยี่ห้อ: ${item.Brand !== undefined && item.Brand !== "" ? item.Brand : "-"},`
                      //      itemDesc += `ชื่อรุ่น: ${item.Model !== undefined && item.Model !== "" ? item.Model : "-"},` 
                      //      itemDesc += `ขนาด: ${item.Size !== undefined && item.Size !== "" ? item.Size : "-"},`
                      //      itemDesc += `สี: ${item.Color !== undefined && item.Color !== "" ? item.Color : "-"}`; 
  
                           let subRowItem = [];
                           subRowItem.push({ "value": itemUpdate.ItemID}); //"รหัสสินค้า"
                           subRowItem.push({ "value": itemUpdate.ItemName}); //"ชื่อสินค้า"
                           subRowItem.push({ "value": catItem.label});//"หมวดหมู่"
                           subRowItem.push({ "value": itemUpdate.ItemDescription});//"รายละเอียดสินค้า"
                           subRowItem.push({ "value": itemUpdate.ItemPropertise});//"คุณสมบัติเฉพาะ"
                           //let imagedata = itemImage.filter(x => x.ItemRowId == item.RowID);
                           let imagedata = itemImage.filter(x => x.ItemRowId == retunInsert.data.RowID);
                           for(let i = 0; i < 5; i++){
  
                            if (imagedata[0].imageData[i] != undefined){
                              let replacePath = imagedata[0].imageData[i].ItemPicPath.replace("..", window.location.origin);
                              subRowItem.push({ "value": replacePath}); 
                            }else{
                              subRowItem.push({ "value": ""});//"รูปที่ i"
                            }
  
                           }
                           subRowItem.push({ "value": itemUpdate.ItemPrice != undefined ? itemUpdate.ItemPrice.toString() : ""});//"ราคาสินค้าต่อหน่วย"
                           subRowItem.push({ "value": itemUpdate.ItemUnit});//"หน่วยนับ"
                           subRowItem.push({ "value": itemUpdate.Quantity != undefined ? itemUpdate.Quantity.toString() : ""});//"จำนวนสินค้า"
                           subRowItem.push({ "value": ""});//"Admin ตรวจสอบ"
                           subRowItem.push({ "value": itemUpdate.Comment});//"ความคิดเห็น"
                           rowItem.push(subRowItem);


                       _template.data.row = rowItem;
                           break;
                }
                
                _template.data.value = setValue;
    
            })
            templateForm.userPrincipalName = userData.Email;
            templateForm.subject = "แก้ไขสินค้าบน e-Catalog"; 
            let returnData = await CreateMemorandum(templateForm);
            console.log(returnData);
            if (returnData != null)
            {
              let returnData = undefined;
              // if (itemUpdate.RowID == undefined || itemUpdate.RowID === 0)
              // {
              //   returnData = await InsertSupplierProduct(itemUpdate);
              // }else{
              //   returnData = await UpdateSupplierProduct(itemUpdate);
              // }

              //returnData = await InsertSupplierProduct(itemUpdate);


                Swal.fire({
                      title: "ส่งข้อมูลขอแกัไขสำเร็จ",
                      //text: returnData.data.documentNo ,
                      icon: "success",
                      confirmButtonText: "ตกลง",
                      allowOutsideClick: false,
                      allowEscapeKey: false
                  }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        setTableLoading(false);
                      } 
                  })
  
            }
            }
            
            //console.log("after" , templateForm);
        }catch(e){
            console.error("createError", e);
        }
  
        setTableLoading(false);
    }

    const transformKeys = (data: any[], keyMap: { [name: string]: string }) => {
      return data.map((item) => {
        let newItem: { [key: string]: any } = {};
        
        //newItem["RowID"] = item["RowID"];  
        Object.keys(keyMap).forEach((key) => {
            const newKey = keyMap[key] || key;
            newItem[newKey] = item[key];  
        });


        // Object.keys(item).forEach((key) => {
        //   if (keyMap[key] != undefined)
        //   {
        //     const newKey = keyMap[key] || key;
        //     newItem[newKey] = item[key];    
        //   }else if (key === "RowID"){
        //     newItem[key] = item[key];    
        //   }
        // });
        return newItem;
      });
    };
    
    const importExcel = async (e: any) => {
      Swal.fire({
        title: "ยืนยันการนำเข้าข้อมูลคงเหลือสินค้า",
        //text: returnData.data.documentNo ,
        //icon: "question",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ไม่ยืนยัน",
        showCancelButton: true,
        confirmButtonColor: "#1890ff",
        cancelButtonColor: "#c95558",
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          setTableLoading(true);
          const file = e.target.files[0];
          try {
            import("xlsx").then((xlsx) => {
              const reader = new FileReader();
              try {
                reader.onload = async (e: any) => {
                  const wb = xlsx.read(e.target.result, { type: "array" });
                  const wsname = wb.SheetNames[0];
                  const ws = wb.Sheets[wsname];
                  const data = xlsx.utils.sheet_to_json(ws, { header: 1 });
                  const cols: any = data[0];
                  data.shift();
                  let _importedData = data.map((d: any) => {
                    return cols.reduce((obj: any, c: any, i: any) => {
                      obj[c] = d[i];
                      return obj;
                    }, {});
                  });
                  if (_importedData.length !== 0) {
                    let res = null;
                    let importData : CategoryItemStockModel[] = [];

                    for (let i = 0; i < _importedData.length; i++) {
                      const element = _importedData[i];
                      //let catName = element["หมวดหมู่"]
                      //var catItem = categoryItem.filter((x) => x.label === catName)[0];
                      if ( _importedData[i]["รหัส"] === undefined) continue;
                      importData.push({
                        ItemID : _importedData[i]["รหัส"],
                        ItemStock : _importedData[i]["จำนวน"],
                      })
                    }

                    res = await UpdateCategoryItemStock(importData)
      
                    if (res?.code === "200") {
                      Swal.fire({
                        title: "อัพเดทข้อมูลสำเร็จ",
                        icon: "success",
                        confirmButtonText: "ตกลง",
                        confirmButtonColor: "#1890ff",
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                          getProducts();
                        } 
                    })
                      
                    }
                    setTableLoading(false);
                  }
                };
      
                reader.readAsArrayBuffer(file);
              } catch (error) {
                setTableLoading(false);
              }
            });
          } catch (error) {
            setTableLoading(false);
          }
          e.target.value = null;
          
        } 
    })

    


      
    };

    // const handleSubmit = async () => {
      
    //   let countCheckNoImage = [];
    //   let itemImage = [];
    //   let checkImage = await Promise.all(supplierList.map( async (item:any) => {
    //       let tempImage = await GetSupplierProductImage({ ItemRowId: item.RowID});
    //       if (tempImage.data == null)
    //         countCheckNoImage.push(item.RowID)
    //       else
    //       {
    //         itemImage.push({
    //           ItemRowId: item.RowID,
    //           imageData: tempImage.data
    //         })
    //       }
    //   }));
    //   console.log(itemImage);
    //   //return ;

    //   console.log(countCheckNoImage);
    //   if (countCheckNoImage.length > 0)
    //   {
    //     Swal.fire({
    //           title: "แนบรูปสินค้าไม่ครบถ้วน",
    //           //text: returnData.data.documentNo ,
    //           icon: "warning",
    //           confirmButtonText: "ตกลง",
    //           showCancelButton: false,
    //           confirmButtonColor: "#1890ff",
    //       });
    //   }else{
    //       Swal.fire({
    //           title: "ยืนยันบันทึกข้อมูลสินค้า",
    //           //text: returnData.data.documentNo ,
    //           //icon: "question",
    //           confirmButtonText: "ยืนยัน",
    //           cancelButtonText: "ไม่ยืนยัน",
    //           showCancelButton: true,
    //           confirmButtonColor: "#1890ff",
    //           cancelButtonColor: "#c95558",
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //           setTableLoading(true);
    //           PrcessObjectJson(itemImage);
    //         }
    //       });
    //   }
      
      
    // }
    const handleSearch = (
      selectedKeys: string[],
      confirm: (param?: FilterConfirmProps) => void,
      dataIndex: DataIndex,
    ) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
    };
  
    const handleReset = (clearFilters: () => void) => {
      clearFilters();
      setSearchText('');
    };
    const getColumnSearchProps = (dataIndex: DataIndex, placeholder: string) => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
          <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
              <Input
                  ref={searchInput}
                  placeholder={`ค้นหา ${placeholder}`}
                  value={`${selectedKeys[0] || ''}`}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                  style={{ marginBottom: 8, display: 'block' }}
              />
              <Space>
                  <Button
                      type="primary"
                      onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                      icon={<SearchOutlined />}
                      size="small"
                      style={{ width: 90 }}
                  >
                      Search
                  </Button>
                  <Button
                      onClick={() => clearFilters && handleReset(clearFilters)}
                      size="small"
                      style={{ width: 90 }}
                  >
                      Reset
                  </Button>
              </Space>
          </div>
      ),
      filterIcon: (filtered: boolean) => (
          <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} rev={undefined} />
      ),
      onFilter: (value, record) => {
          return record[dataIndex] != null && record[dataIndex]
              .toString()
              .toLowerCase()
              .includes((value as string).toLowerCase())
      },
      //onFilterDropdownOpenChange: visible => {
      //    if (visible) {
      //        setTimeout(() => searchInput.current?.select(), 100);
      //    }
      //},
      render: text =>
          searchedColumn === dataIndex ? (
              <Highlighter
                  highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                  searchWords={[searchText]}
                  autoEscape
                  textToHighlight={text ? text.toString() : ''}
              />
          ) : (
              text
          ),
  });

    const columns = [
      {
          title: 'รหัส',
          dataIndex: 'itemId',
          key: 'itemId',
          width: "10%",
          ...getColumnSearchProps('itemId', 'รหัส')
        },
      {
        title: 'ชื่อสินค้า',
        dataIndex: 'title',
        key: 'title',
        width: "55%",
        ...getColumnSearchProps('title', 'ชื่อสินค้า')
      },
      {
          title: 'หมวดหมู่',
          dataIndex: 'catagolyGroupItemName',
          key: 'catagolyGroupItemName',
          width: "15%",
          ...getColumnSearchProps('catagolyGroupItemName', 'หมวดหมู่')
        },
        // {
        //   title: 'รายละเอียดสินค้า',
        //   dataIndex: 'description',
        //   key: 'description',
        //   width: "10%",
        //   ...getColumnSearchProps('description', 'รายละเอียดสินค้า')
        // },
        // {
        //   title: 'คุณสมบัติเฉพาะ',
        //   dataIndex: 'itemProperties',
        //   key: 'itemProperties',
        //   width: "10%",
        //   ...getColumnSearchProps('itemProperties', 'คุณสมบัติเฉพาะ'),
        //   render: (text) => {
        //     return <div dangerouslySetInnerHTML={{ __html: text }}></div>
        //   }
        // },
        // {
        //   title: 'ขนาด',
        //   dataIndex: 'Size',
        //   key: 'Size',
        //   width: "10%",
        //   ...getColumnSearchProps('Brand', 'ขนาด')
        // },
        // {
        //   title: 'สี',
        //   dataIndex: 'Color',
        //   key: 'Color',
        //   width: "10%",
        //   ...getColumnSearchProps('Color', 'สี')
        // },
        
        // {
        //   title: 'ผู้ผลิต',
        //   dataIndex: 'Manufacturer',
        //   key: 'Manufacturer',
        //   width: "10%",
        //   ...getColumnSearchProps('Manufacturer', 'ผู้ผลิต')
        // },
        {
          title: 'ราคา',
          dataIndex: 'price',
          key: 'price',
          width: "10%",
          ...getColumnSearchProps('price', 'ราคา'),
          render: (text) => {
            var checkData = text != null ? parseFloat(text).toFixed(2) : 0.00;
            var textData = checkData === "0.00" ? "-" : checkData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return <div style={{textAlign: "right"}}>{textData}</div>;
          }
        },
       
        // {
        //   title: 'จำนวน',
        //   dataIndex: 'Quantity',
        //   key: 'Quantity',
        //   width: "10%",
        //   ...getColumnSearchProps('Quantity', 'จำนวน')
        // },
        {
          title: 'หน่วยนับ',
          dataIndex: 'itemUnit',
          key: 'itemUnit',
          width: "10%",
          ...getColumnSearchProps('itemUnit', 'หน่วยนับ')
        },
        {
          title: 'Stock',
          dataIndex: 'itemStock',
          key: 'itemStock',
          width: "10%",
          ...getColumnSearchProps('itemStock', 'Stock'),
          // render: (text) => {
          //   var checkData = text != null ? parseFloat(text).toFixed(2) : 0.00;
          //   var textData = checkData === "0.00" ? "-" : checkData.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          //   return <div style={{textAlign: "right"}}>{textData}</div>;
          // }
        },
       
    ];

    const handleSaveModal2 = async (values) => {

      Swal.fire({
        title: "ยืนยันบันทึกแก้ไขจำนวนสินค้า",
        //text: "การบันทึกเพื่อแก้ไขข้อมูลสินค้าจะต้องทำการอนุมัติเพื่อปรับปรุงข้อมูล",
        //icon: "question",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ไม่ยืนยัน",
        showCancelButton: true,
        confirmButtonColor: "#1890ff",
        cancelButtonColor: "#c95558",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setTableLoading(true);

        setConfirmLoading(true);

        let importData : CategoryItemStockModel[] = [];

        importData.push({
          ItemID :  values.itemId,
          ItemStock : values.itemStock,
        })
        await UpdateCategoryItemStock(importData)
        form2.resetFields();
        setConfirmLoading(false);
        //fetchReport(categoryItem);
        
        setOpenModalStock(false)
        await getProducts();
        setTableLoading(false);

        }
      });

        
      }
    
    if (isLoad) {
      return <></>;
    } else {
      return (
        <Layout>
          {/* <Sider width={250} className={styles.side_bars_sup_list}>
            <div className={styles.filter_func}>
              <FilterOutlined rev={undefined} />
              สินค้าบน E-Catalog
            </div>
          </Sider>
          
          <Sider width={300} className="side-bars">
          {sidebar} 
          </Sider>*/}
          <Layout className={styles.layout_content}>
            <Content className={styles.contents}>
              <div className={styles.content_header}>
                <p className={`${styles.p_tag} ${styles.header}`}>สินค้าของฉัน</p>
                <div className={styles.header_button} >
                {/* <Button className={styles.button_add} size="large" onClick={() => {
                  setItemOnModal(undefined);
                  setContentEditor((prevState: any) => ({
                    ...prevState,
                    value: "",
                  }));
                  setFileList([]);
                  //form.resetFields();
                  
                  setOpenModal(true);

                }}>
                  เพิ่มสินค้าด้วยตัวเอง
                </Button> */}
               

                <Button className={styles.button_import} size="large" onClick={() => inputFile.current.click() }>
                  นำเข้าข้อมูลสินค้าคงเหลือด้วย Excel
                </Button>
                <>
                    <input
                      type="file"
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      onChange={importExcel}
                      style={{ display: "none" }}
                      id="file"
                      ref={inputFile}
                    />

                  </>
              
                <Button className={styles.button_export} size="large" onClick={async () => {
                      await exportExcel([],
                        "stock_data",
                        tableDataExport,
                        setExportLoading
                      );
                    }}>
                  ส่งออกสินค้าคงเหลือไปยัง Excel
                </Button>
                </div>
                
              </div>
           
 <Table rowKey={record => record.id}
                    className={'main-table-product'}
                    bordered
                    dataSource={products}
                    columns={columns} /*scroll={{ x: 4000, y: 700 }}*/ loading={tableLoading}
                    pagination={{ position: ['bottomCenter'] }}
                    rowSelection={{
                      type: "checkbox",
                      renderCell: (value, record, index, originNode) => {
                        return (
                          <>{actionBodyTemplate(record)}</>
                        );
                      },
                    }}
                />



                          
            </Content>
          </Layout>
          <Modal
            title="ข้อมูลสินค้า"
            className={styles.modal_product }
            centered
            closable={false}
            maskClosable={false}
            visible={openModal}
            // onOk={() => {
              
            // } }
            //onCancel={() => setOpenModal(false)}
            //confirmLoading={confirmLoading}
            width={1000}
            footer={[
              <Button key="modalback" className={styles.btn_not_accept} onClick={() => setOpenModal(false) } disabled={confirmLoading}>
                ยกเลิก
              </Button>,
              <Button key="modalsubmit" className={styles.btn_accept} type="primary" loading={confirmLoading} onClick={() => {
                form.validateFields()
              .then(async values => {
                  //form.resetFields();
                  //onCreate(values);
                 await handleSaveModal(values);
              })
              .catch(info => {
                  console.log('Validate Failed:', info);
              });
              }}>
                บันทึก
              </Button>
            ]}
      >
            <Form form={form} name="control-hooks" initialValues={itemOnModal}>
                <Form.Item hidden name="id"></Form.Item>
                <Form.Item label="รหัส" name="itemId" rules={[{ required: true, message: 'กรอกรหัสสินค้า' }]} >
                  <Input maxLength={10} disabled={true}></Input>
                </Form.Item>
                <Form.Item label="ชื่อสินค้า" name="title" rules={[{ required: true, message: 'กรอกชื่อสินค้า' }]}>
                  <Input></Input>
                </Form.Item>
                <Form.Item label="หมวดหมู่" name="catagolyGroupItemID" rules={[{ required: true, message: 'กรอกหมวดหมู่' }]}>
                <Select
                    showSearch
                    //placeholder="Search to Select"
                    optionFilterProp="children"
                    filterOption={(input, option) => (option?.label ?? '').includes(input)}
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    options={categoryItem}
                  />
                </Form.Item>
                {/* <Form.Item label="ยี่ห้อ" name="Brand">
                  <Input></Input>
                </Form.Item>
                <Form.Item label="ชื่อรุ่น" name="Model">
                  <Input></Input>
                </Form.Item>
                <Form.Item label="ขนาด" name="Size">
                  <Input></Input>
                </Form.Item>
                <Form.Item label="สี" name="Color">
                  <Input></Input>
                </Form.Item> */}
                <Form.Item label="รายละเอียดสินค้า" name="description" style={{marginBottom: "8px"}}>
                  <TextArea rows={4}  maxLength={1000} />
                </Form.Item>
                <Form.Item label="คุณสมบัติเฉพาะ" style={{marginBottom: "8px"}}>
                <Editor
              onInit={() => {
                //setLoading(false);
              }}
              init={{
                // selector: "textarea#file-picker",
                statusbar: false,
                paste_data_images: false,
                menubar: false,
                content_css: false,
                // auto_focus: "elm1",
                height: "20vh",
                fullscreen_native: false,
                remove_script_host: false,
                relative_urls: false,
                image_title: false,
                automatic_uploads: false,
                image_sourcetab: false,
                image_advtab: false,
                plugins: [
                  "image code",
                  "advlist autolink lists image charmap print preview hr anchor pagebreak",
                  "searchreplace wordcount  code fullscreen",
                  "insertdatetime media nonbreaking save table contextmenu directionality",
                  "emoticons template paste textcolor colorpicker textpattern imagetools  image",
                  "link",
                ],
                toolbar1:
                  "styleselect | fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist",
                  //"insertfile undo redo | styleselect | fontselect | fontsizeselect | bold italic underline |  forecolor backcolor | alignleft aligncenter alignright alignjustify | searchreplace | bullist numlist outdent indent | pagebreak | link table | image | fullscreen",
                fontsize_formats:
                  "8pt 10pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 36pt",
              }}
              value={contentEditor?.value}
              
              onEditorChange={handleEditorChange}
            />
                </Form.Item>
                 <Form.Item label="แนบรูปภาพสินค้า" required>
                <Upload key={"upload-product"}
                  listType="picture-card"
                  fileList={fileList}
                  onChange={handleChange}
                  maxCount={5}
                  multiple
                  beforeUpload={(file) => {
                    setFileList([...fileList, file]);
              
                    return false;
                  }}
                  onRemove={(file) => 
                    {
                      const index = fileList.indexOf(file);
                      const newFileList = fileList.slice();
                      newFileList.splice(index, 1);
                      setFileList(newFileList);

                      setFileListRemove([...fileListRemove, file]);
                    }
                  } 
                >
                  {fileList.length >= 5 ? null : uploadButton}
                </Upload>
                </Form.Item>
                <Form.Item label="ราคาสินค้าต่อหน่วย" name="price" hidden={true}>
                  <Input type="number" ></Input>
                </Form.Item>
                {/*<Form.Item label="จำนวนสินค้า" required name="Quantity" rules={[{ required: true, message: 'กรอกจำนวนสินค้า' }]}>
                  <Input type="number"></Input>
                </Form.Item> */}
                <Form.Item label="หน่วยนับ" required name="itemUnit" rules={[{ required: true, message: 'กรอกหน่วยนับ' }]}>
                  <Input></Input>
                </Form.Item>
                <Form.Item label="เลขที่สัญญาจะซื้อขาย" name="Contract" hidden={true}>
                  <Input></Input>
                </Form.Item>
            </Form>
          </Modal>
          <Modal
            title="แก้ไขข้อมูลจำนวนสินค้า"
            className={styles.modal_product }
            centered
            closable={false}
            maskClosable={false}
            visible={openModalStock}
            // onOk={() => {
              
            // } }
            //onCancel={() => setOpenModal(false)}
            //confirmLoading={confirmLoading}
            width={1000}
            footer={[
              <Button key="modalback" className={styles.btn_not_accept} onClick={() => setOpenModalStock(false) } disabled={confirmLoading}>
                ยกเลิก
              </Button>,
              <Button key="modalsubmit" className={styles.btn_accept} type="primary" loading={confirmLoading} onClick={() => {
                form2.validateFields()
              .then(async values => {
                  //form.resetFields();
                  //onCreate(values);
                 await handleSaveModal2(values);
              })
              .catch(info => {
                  console.log('Validate Failed:', info);
              });
              }}>
                บันทึก
              </Button>
            ]}
      >
            <Form form={form2} name="control-hooks" initialValues={itemOnModal}>
                <Form.Item hidden name="id"></Form.Item>
                <Form.Item label="รหัส" name="itemId" rules={[{ required: true, message: 'กรอกรหัสสินค้า' }]} >
                  <Input maxLength={10} disabled={true}></Input>
                </Form.Item>
                <Form.Item label="ชื่อสินค้า" name="title" rules={[{ required: true, message: 'กรอกชื่อสินค้า' }]}>
                  <Input disabled={true}></Input>
                </Form.Item>
                <Form.Item label="จำนวนสินค้า" required name="itemStock" rules={[{ required: true, message: 'กรอกจำนวนสินค้า' }]}>
                  <Input type="number"></Input>
                </Form.Item>
                <Form.Item label="หน่วยนับ" required name="itemUnit" rules={[{ required: true, message: 'กรอกหน่วยนับ' }]}>
                  <Input disabled={true}></Input>
                </Form.Item>
            </Form>
          </Modal>
        </Layout>

        
      );
    }
  };
  
  export default SupplierMyProduct;


